import React from 'react';

import Period from 'components/Period';

import { Tooltip } from '@gogame/components';
import { DateValueFormatter } from '@gogame/intl-ts';
import { useScreenState } from '@gogame/screens';

const FilterView = ({ dataCy, base, compare, baseTooltip, compareTooltip }) => (
  <span data-cy={dataCy}>
    <Tooltip title={baseTooltip} placement={'top'} wrapper inlineWrapper>
      {base}
    </Tooltip>
    {compare ? (
      <React.Fragment>
        {' / '}
        <Tooltip title={compareTooltip} placement={'top'} wrapper inlineWrapper>
          {compare}
        </Tooltip>
      </React.Fragment>
    ) : null}
  </span>
);

const TrackerPresetDescription = () => {
  const { filtersCollection } = useScreenState();
  const [baseFilters, compareFilters] = filtersCollection;

  return (
    <React.Fragment>
      <FilterView
        dataCy={'period'}
        base={<Period value={baseFilters.period} />}
        compare={
          compareFilters ? <Period value={compareFilters.period} /> : null
        }
        baseTooltip={'Period'}
        compareTooltip={'Compare period'}
      />
      {' | '}
      <FilterView
        dataCy={'payTo'}
        base={
          <DateValueFormatter
            value={baseFilters.payTo}
            template={'LL'}
            timeZone={'utc'}
          />
        }
        compare={
          compareFilters ? (
            <DateValueFormatter
              value={compareFilters.payTo}
              template={'LL'}
              timeZone={'utc'}
            />
          ) : null
        }
        baseTooltip={'Pay to'}
        compareTooltip={'Compare pay to'}
      />
    </React.Fragment>
  );
};

export default TrackerPresetDescription;
